import { useMemo } from "react";

import { useAllEmployees } from "~api/employees";
import { Ability } from "~auth/Ability.ts";
import { usePermitted } from "~auth/usePermitted";
import { useCurrentTenant } from "~contexts/CurrentTenantContext/CurrentTenantContext";
import type { Employee } from "~generated";
import { isAmbiguousAddress, isSuperiorRequired } from "./helpers";

export function useEmployeeAdministrationTaskBar() {
  const permitted = usePermitted();
  const currentTenant = useCurrentTenant();

  const { data: allEmployees } = useAllEmployees();
  const tenantEmployees: Employee[] | undefined = useMemo(
    () =>
      allEmployees?.filter(
        (employee) =>
          employee.tenant_id === currentTenant.id &&
          employee.resigned_at === null,
      ),
    [allEmployees, currentTenant.id],
  );

  const superiorMissingCount =
    tenantEmployees?.filter(isSuperiorRequired).length ?? 0;

  const ambiguousAddressCount =
    tenantEmployees?.filter(isAmbiguousAddress).length ?? 0;

  const hasMissingSuperiors =
    permitted([Ability.canManageOrganigram]) && superiorMissingCount > 0;
  const hasAmbigousAddresses =
    permitted([Ability.canAccessEmployeeAdministration]) &&
    ambiguousAddressCount > 0;

  return {
    superiorMissingCount,
    ambiguousAddressCount,
    hasMissingSuperiors,
    hasAmbigousAddresses,
  };
}
